import gridComponentBase from "@/components/grid/gridComponentBase.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { TextValueItem } from "@/models/TextValueItem";
import api from "@/services/api";
import permessi from "@/config/permessi";
import { CodiciPagamento } from "@/models/anafrafica/codiciPagamento";

const _ENDPONT = api.endpoint.AMMINISTRAZIONE.CODICI_PAGAMENTO;
@Component({})
export default class iCodiciPagamento extends gridComponentBase {
	get PERMESSI(): string[] {
		return [permessi.BK.Amministrazione.CODICI_PAGAMENTO];
	}
	editItem: CodiciPagamento = new CodiciPagamento();
	showEditModal: boolean = false;
	editSubTitle: string = "";
	editTitle: string = "";
	kendop: any = kendo;

	showOnlyActive: boolean = false;

	get columns(): Array<any> {
		return [
			{ field: "itemID", title: "ID", width: 20, filterable: false, hidden: true, headerCell: "myHeaderCellTemplate", editHide: true },
			{ field: "codicePagamento", title: this.$i18n.t("generico.codicePagamento").toString(), headerCell: "myHeaderCellTemplate", width: this.setColPercent(15) },
			{ field: "descrizione", title: this.$i18n.t("generico.descrizione").toString(), groupable: true, headerCell: "myHeaderCellTemplate", export: true, },
			{
				field: "ultimaModifica",
				title: this.$i18n.t("generico.ultimaModifica").toString(),
				type: "datetime",
				headerType: "daterange",
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				export: true,
				width: this.setColPercent(15),
				editDisabled: true
			},
			{
				field: "verificaLimite",
				title: this.$i18n.t("generico.verificaLimite").toString(),
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				export: true,
				type: "boolean",
				filterType: "boolean",
				width: this.setColPercent(15),
				disabled: true,
			},
			{
				field: "immediato",
				title: this.$i18n.t("generico.pagamentoImmediato").toString(),
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				export: true,
				width: this.setColPercent(15),
				type: "boolean",
				filterType: "boolean",
				disabled: true,
			},
			{
				field: "mesiLimite",
				title: this.$i18n.t("generico.mesiLimite").toString(),
				type:"numeric-int",
				filterType:"numeric-int",
				groupable: true,
				headerCell: "myHeaderCellTemplate",
				export: true,
				width: this.setColPercent(15)
			},

			{ field: "_actions", title: " ", width: 50 + (this.canDelete ? 50 : 0), cell: "defaultCellTemplate", type: "actions_list", filterable: false, headerCell: "myHeaderCellTemplate" }
		];
	}

	sort: any = [{ field: "codicePagamento", dir: "asc" }];

	created() {
		var self = this;
		this.take = 60;
		this.pageable.pageSize = 60;
		this.pageSize = 60;
		if (this.group) {
			this.group.map(group => (group.aggregates = this.aggregates));
		}
		this.group = this.group;

		Promise.all([])
			.then(responses => {
				self.getData();
			})
			.catch(err => {
				console.log(err);
			});
	}

	getData() {
		this.getGridData(`${_ENDPONT}`);
	}

	onDelete(item: any) {
		var self = this;
		var message = self.$createElement("div", { domProps: { innerHTML: `<h5>${item.itemID}</h5>${self.$i18n.t("messaggio.confermaCancellazione")}` } }); // h('div', { domProps: { innerHTML: 'Title from <i>HTML<i> string' } })
		var title = this.$i18n.t("titolo.elimina", [this.$i18n.t("generico.codicePagamento")]).toString();
		self.deleteGridRow(_ENDPONT, item.itemID, title, [message]);
	}

	addNewRow() {
		let newItem = new CodiciPagamento();

		this.onEdit(newItem);
	}

	onEdit(item: any) {
		var self = this;
		self.editItem = Object.assign(new CodiciPagamento(), item);
		self.editSubTitle = "";
		self.editTitle = item.itemID;
		self.showEditModal = true;
	}

	onSaveEdit() {
		var self = this;
		var title = this.$i18n.t("msg.salvataggioRiuscito").toString();
		var message = this.$i18n.tc("msg.salvato_iCorrettamente", 1, { obj: this.$i18n.t("generico.codicePagamento") }).toString();
		self.setGridRow<CodiciPagamento>(_ENDPONT, self.editItem, title, message, self.isNewItem).then(res => {
			self.showEditModal = false;
		});
	}

	get isNewItem(): boolean {
		return (this.editItem || {}).itemID == null || (this.editItem || {}).itemID <= 0;
	}
}
